import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allYlInfoRes: '',
    mapCheckedId:0,
  },
  mutations: {
    updateAllYlInfoRes(state, data) {
      state.allYlInfoRes = data;
    },
    setMapCheckedId(state, data) {
      state.mapCheckedId=data
    }
  },
  actions: {
  },
  modules: {
  }
})
